<template>
  <div class="background-gradient">
    <div class="top-blue-container">
      <div class="top-nav-card">
        <div class="top-left-avatar">
          <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'" alt="avatar" class="avatar-wrapper" />
        </div>
        <div class="top-center-info">
          <div class="username-row">
            <div class="username-text">{{ $store.state.userInfo.username || $store.state.userInfo.userid || $store.state.userInfo.id || $store.state.userInfo.user_id || $store.state.userInfo.account || $store.state.userInfo.name || $store.state.userInfo.nickname || '' }}</div>
            
            <div class="right-buttons-top">
              <div class="settings-btn-top" @click="$parent.goNav('/userInfo')">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAARVBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////9X1DS3AAAAFnRSTlMAGS/foQqV7bPpd77Q+KjIWkuehmc9s4NUtAAAARhJREFUOMuNlFkShCAMRAPI5gau9z/qOAQLGIhO/yDyKiakI8BXrDfCJg3Q1DadhURxejBch/NHY0HFbUWdOqOWa79eax8jmCSVKB8OO5BhHXg76x1j9BiMKO3+0gJgrmVibxQIOtiG1PF91rGSWgqrxqwtha05FbCuQc3YjztrAjMlRWDYmVHCIzYGymVvGphEqrimGmMiUAZ33Hu/NDBmAzXnFcsK4zpQKr9kXWF8Kqk2dmAbN3jElttej1g04Q6PmMS8PDxjmL+HNww4WvUNg90Dja1AK2L6P0ykLjfVXec2DqCkMY3G63M7EON19Y6hbdoDzXAIWRpaZ2o5bMuaGZ+WKKxPUqwc8Lbm7Ba4clbXsk7Ff8MHTt0sQUfXju4AAAAASUVORK5CYII=" alt="Settings" class="icon-img" />
                <span>{{ $t('Settings') }}</span>
              </div>
              <button type="button" class="customer-service-top" aria-label="联系客服" @click="openKefu">
                <svg class="customer-service-top-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 13v-2a8 8 0 0 1 16 0v2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  <rect x="3" y="12" width="4" height="7" rx="2" fill="none" stroke="currentColor" stroke-width="2" />
                  <rect x="17" y="12" width="4" height="7" rx="2" fill="none" stroke="currentColor" stroke-width="2" />
                  <path d="M19 19c-.7 2-2.3 3-4.8 3H12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
              </button>
            </div>
          </div>
          <div class="days-text">{{ $t('Joined for') }}{{ $store.state.userInfo.joinday || 0 }}{{ $t('days') }}</div>
        </div>
      </div>

      <div class="balance-card-section">
        <div class="balance-card-info">
          <div class="balance-card-label">{{ $t('My Balance') }}</div>
          <div class="balance-card-amount">
            <span class="currency">￥</span>
            <span class="amount">{{ formatBalance($store.state.userInfo.balance) }}</span>
            <img :class="{ 'rotate': isRefreshing }" @click="refreshBalance" src="/static/style/sx.png" alt="Refresh" class="refresh-icon-balance" />
          </div>
        </div>
        
        <div class="balance-card-buttons">
          <button class="btn-deposit" @click="$parent.goNav('/recharge')">{{ $t('Deposit') }}</button>
          <button class="btn-withdraw" @click="$parent.goNav('/withdrawal')">{{ $t('Withdraw') }}</button>
        </div>
      </div>
    </div>

    <!--
    <div class="vip-card-section">
      <div class="vip-card-info">
        <div class="vip-card-level">{{ $t('Current Level VIP') }}{{ $store.state.userInfo.vip || 0 }}</div>
        <div class="vip-card-growth-value">VIP{{ vipTab }}{{ $t('Growth Value') }}{{ userStats.flow || 0 }}/{{ currentVipFlow || 0 }}</div>
      </div>
      <div class="vip-card-next-tip" v-if="vipLis.length > 0 && nextVipInfo">
        距离 VIP{{ nextVipInfo.level }} 还差充值 {{ formatVipAmount(nextVipInfo.rechargeRemaining) }}，流水 {{ formatVipAmount(nextVipInfo.flowRemaining) }}
      </div>
      <div class="vip-card-next-tip vip-card-next-tip--done" v-else-if="vipLis.length > 0">
        已达到最高 VIP 等级
      </div>
      <div class="vip-card-progress">
        <div class="vip-card-progress-bar">
          <div class="vip-card-progress-fill" :style="{ width: (vipProgress || 0) + '%' }"></div>
        </div>
      </div>
      <div class="vip-card-tabs">
        <div class="vip-card-tab" @click="$parent.goNav('/vip')">{{ $t('Promotion Bonus') }}</div>
        <div class="vip-card-tab" @click="$parent.goNav('/vip')">{{ $t('Monthly Bonus') }}</div>
        <div class="vip-card-tab" @click="$parent.goNav('/vip')">{{ $t('Weekly Bonus') }}</div>
        <div class="vip-card-tab" @click="$parent.goNav('/vip')">{{ $t('Exclusive Events') }}</div>
      </div>
    </div>
    -->

    <div class="recover-card-section">
      <div class="recover-card-copy">
        <div class="recover-card-title">场馆余额回收</div>
        <div class="recover-card-desc">一键将各游戏场馆余额回收到主钱包</div>
      </div>
      <button
        class="recover-card-btn"
        type="button"
        :disabled="recovering"
        @click="transall"
      >
        {{ recovering ? '回收中...' : '一键回收' }}
      </button>
    </div>

    <div class="function-grid-section">
      <div class="function-grid-wrapper">
        
        <div class="function-card-item" @click="$parent.goNav('/transRecord')">
          <svg class="function-card-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#f5f7fa" />
            <path d="M16 12h16v24l-4-3-4 3-4-3-4 3V12z" fill="none" stroke="#6b8ebf" stroke-width="3" stroke-linejoin="round"/>
            <path d="M20 18h8M20 24h8" stroke="#6b8ebf" stroke-width="3" stroke-linecap="round"/>
          </svg>
          <span>{{ $t('Fund Details') }}</span>
        </div>
        
        <div class="function-card-item" @click="$parent.goNav('/betRecord')">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK0AAACtCAMAAAD1cQ9xAAAAYFBMVEVHcEzz+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/f5Orz+P8qKioAXOA0NTW+wsfU2d98rPBAhunp7fVJSUqmqa2JjI+2ub7A2PloaWtvpO/IzNKanaE0bcrGAAAADnRSTlMAhnFc16q/7g8iSZg32cdhaewAAATzSURBVHja7Z1tT+MwDMeXNI9NlV230bEx4Pt/y0Njxx1jWxPbjRPp/i+QkPrih3FtJ03s1YpSzvedlEKIED5+yK4fvFtVqKETWtl4Q9Zo0ftqQH0XVJyTNaJnN7PrtI3JUqJnNKo0MVdWdxwmdgDUL+DCrL2OGFnhC5pVRbRMGRf2wkYSqeUdwoVIJyuXZaWyawn7SmLWM+9C/turuIj0AvHB67iYyN23s3FBqYHUsCYuLNGKYS/ZwlcYYh8EX5Jg5lUspEAQt2wsJrQ3yFhSFhcbQiwri8hsTsfiAmcKZyKDREuwQFynIpNCS7AAXC43ADkDL2xuZNCRWTlFg4js6itNt3eyWmrNMMQapNL2y5ytgjbqJFoTK5Fs4w37o/n6sa8Hdt51ORNuvuvqWJW6ZvzgHHVdA8ErrRwLsTr1lSexq7hQf15IyRFdjbB3XzRVJe2dF03GSnWzdrS10oaWTHvLuM7WS6sbCQgXuUYCwu39hb5m2B8xF5XGjvvxofYH2oTmUbDrWWFxFd1ibJynXW8pl2iY8DUlwK6PhBkC946l2PYN+56RVeEptBvCqhzgCMfT/o8+ed43N3X8/Fu+Hj69Y/NZviNsT8nv0Q/L7484V8h2hGlM/l9nPJroCtlZd79G0a4xUSE7NWzWSFpIslDQyvaEpd0jqlwDc4TT86fexwTaw+Xhw/m3EbHLlB2/roLA+DD+j98fhtNqYEXz3ZgX6x2nm9p+f3gLp1XABdlN2nvl4pqK9tNxAw1tWubF0PawNc4VbU4NhqGVsCIBQPtGQKthy4arkHWYh/0KsBhaBattrwPsaRZ2oqCNsD2aH+lgu3mof0IxitaDKvERXkmhaHvQ2pyLtgNt0nDRCtAqh4v2o8SN7dDqlWuI1oD2lLhoFegb2X/atFV6T0K7e3qg3VQX7dOvx5poaCMJ7csM7K/Xmmh3c7RPTdl2R+W3JDHhNdW0VdDGl90DvdBFsLZyWVu0bVU1jdW3ba0dGlqXSdBZQMY1r2iH1oOOUXDROtABO6b69rzd3Ex9qyn2b4vVtwJ2QJipvu0ovjvEOM3RvpDQetg5Vp761gK/l/HUtxr4LZIn3krgESAe2gF4AJuF1kIPqrDQBuiVDBbaDno+lIXWQc/ectBq8O0cDtoOfFSYg9aBj2Ez0Gr4BR0G2h5+Q6c8rUKcbS5PKxFH8svTesR1B8Rx5QlEGzAXYy8H0rYAPYNoPeYuyWmN1B4RvrKNe8TSnkCVLdS4I5J2yoI1yCvdSOM+o02bZ9wNxroHtNfmbixMh5nbLvdvwWyxAaHme1CilXvd58Wja+XO/FUV/qPPWnXXDU3t3VSSXrEqL3fPtP6oyxfMbO/FmuLBfIcd3UQ8qK9PSVKbsKES11WJbUNbcdqK2gGlN5LUTbxhtTSKy+xsxx0Y9CpLvDktE5YX16xW7eAayEwFLlwNGwDhVRM+y4mLaN5cPu7i2roX7sGF7eJdcqVm8Q3oyxWQhmIajC/kvFSt8ktUkJZuKsWgKk0JLJ39LfV4kiXNqxcYtiQXCg4LzVHxS7jDgjN1BupgZsOiE7doecPiw6sGTWbXIoO2SPzXymJT19AzwUzhgWtDAAc0JThGHPbaQlCHFZcGkeMS1kjuwZGuFylRzWo51DKXc+iEuWdlq7SsaBjn39A2dFIErbX5kNbhPOmU0qC/AeggEimpppznAAAAAElFTkSuQmCC" alt="Bet Records" class="function-card-icon" />
          <span>{{ $t('Bet Records') }}</span>
        </div>
        
        <div class="function-card-item" @click="$parent.goNav('/userCent')">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK0AAACtCAMAAAD1cQ9xAAAAV1BMVEVHcEzz+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P/z+P8qKioAXOBtb3E9PT7IzNKFh4tVVlebnqGeoaVxpe/D2vkkc+Xc5O+av/SLrd+1uL11zEmIAAAADHRSTlMAcuG0D4bMJPRYPZ7iDpYgAAAFCUlEQVR42tWdi07jMBBF47cdm1IK2zao//+dW2gpgTyIx2N7fKWVUKQlR8PNeOLY467DlDS9Y0wp5a//GHOuNx1Byd4pwW2YEdeeEYI2zPPwl6xQvaxO6oQNm6VVXxFV6RAr610rqF/ApSPsREgRV+UeO6l4SJUVZQJsvA0o0q4Aa8BTZl5U1sy8UtmArlz+dTxkkc8wxhkdcsmi2yGHCUZ2MI0E9h5ehgfLbMgugeReKUIJWZTk0PNQSAhucDYUU7IbVCgpbRqw7KiUTDCv1KG04COF4aGCXEuwwNRQCxaEWw8WgFsTNtq7sipsJG6F1JVQNIhQW9wQHW4XcLfWDC5QkNiYDiwJ2qBaSAdxiUFQgQ3WNGLae7nbimm3WVdTgv1rkGCBlnQ7PvirHBPUYNfyggv0tDykcYK0i2OEoggb+MKQa0nSLjxonibsfO1oiIZ2PrhUQ3vNYrKh0M4FV9GFnaYFSTi005zLKMNOgstJ04aflWMf+9+Hw3OCDi+Rt/NJ6evwlKjnyBvKhGfs+SlZrwM4ibHisLHR1eAqfHhC0SXqpt9VuakQ2qsXgK+/kUbYf95sfwDr9fYLgFYQENoLPHu+AGgfVojNCDfal8K0DPjyWIdWAIeGOrQWWCPUob3XCjK0Qctgcx6VaAXsraESrYVNglaivWVc2wqtiy8SKtIq0MRiLVoBen+sRctBczTxtO/n8zGd1oLmw9dpf5F9XtpddU6m/UgKHJf2+EF2nF7a7U7JtD0gga3STsgel3bpsXXxVcIq7RfZbnrplE7LAOl2hfYB++3SGVgwrYqfpVmh/Ybd7d6XYcG0HvLVaYl2DHv3wiwsmFYg0j7Izg8vzMOCaTVkKnSe9pvs9OWFBVgCtGOy28/nJdj6tD/JzmMDnwI12l9hPK3C1qad/M2Pa7CVad+nZOcV2Lq0w51sPH98WoFNoEXItzey8zCpEs+nQI/206UTstPxOOC+O1zHMpQ64f14LPCmc60TUGuw7LSyIVrWdW3R8nZoe8hawGq0psx8AhKthCyjqDlX09Y8WFtzjG3N37YzN96DFoJV/e7Q1jcdA6Md4LQDiFalfIv8B6e9JHyLBH7nfXoFC7Ka4rEQKNa4B5y1H88Q28Z/6EVaVxP5mDLolow3DNhDfAEGXB96KO6D0VLG+FLh8prGun8LsPwF3J1zeUvQJf5+fSvrWX8aAWKF0lK0N+gsZQSqO3Tmhoa7LG1ah7Ekf/gXrZfUZwy8Jn/Y5x9wf466KVtJQENE/DTCzGYSSBKDjWNDWvoCJ7F9Gdq53YaA4F4gsG8YoQU59xK/1eEfgmspD78LG6Zp7jBbavtAcx8Ua2Vf94d0K3vmf1fhkz5r5GA99W4qWx4xak0/ZitF2l7wLXTW2eYDYnlhS7MlOtuQN7UJo2Ldja2LaFhXb20LRWF2wW5uuSV1E08YnUEiqlVc7cQQ2TWwr4qruq4dXN917eACYOvhgmBr4aoOqBrtOROaN5vSw0RaW/fCrZCTu3iXLHF0egP6ci28UQ4jKPSsYbXKl74NF+Q+iALZBYXCy7GP+8gZXoV/1ofMdXyGznOOiskxVPB8Z9T0Gj1tZT3UzGHyWpX9ADY0Xq6KHBbXY/hXs2IH25nEM8FKnQc2CrBtIKyjBOwgwFpVO41R9lGWsMLVPjjSOL8lS3DB+o6GbkdxLkVUe+YIniD6ccqp8l7c5L1izhnMJ+o/15NdAeyN5E4AAAAASUVORK5CYII=" alt="Personal Report" class="function-card-icon" />
          <span>{{ $t('Personal Report') }}</span>
        </div>
        
        <div class="function-card-item" @click="$parent.goNav('/welfare')">
          <img src="data:image/png;base64,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" alt="Promotions" class="function-card-icon" />
          <span>{{ $t('Promotions') }}</span>
        </div>
        
        <div class="function-card-item" @click="$parent.goNav('/shareMoney')">
          <img src="data:image/png;base64,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" alt="Share & Earn" class="function-card-icon" />
          <span>{{ $t('Share & Earn') }}</span>
        </div>
        
        <div class="function-card-item" @click="$parent.goNav('/agentCenter')">
          <svg class="function-card-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#f5f7fa" />
            <circle cx="24" cy="18" r="5" fill="none" stroke="#6b8ebf" stroke-width="3"/>
            <path d="M14 34c0-5 4-9 10-9s10 4 10 9" fill="none" stroke="#6b8ebf" stroke-width="3" stroke-linecap="round"/>
            <path d="M24 28l-2 6h4l-2-6z" fill="#4a90e2"/>
          </svg>
          <span>{{ agentPromoMode === 'turnover' ? $t('Turnover Rebate') : $t('Agent Center') }}</span>
        </div>
        
        <div class="function-card-item" @click="$parent.goNav('/language')">
          <svg class="function-card-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#f5f7fa" />
            <circle cx="24" cy="24" r="11" fill="none" stroke="#6b8ebf" stroke-width="3" />
            <ellipse cx="24" cy="24" rx="5" ry="11" fill="none" stroke="#6b8ebf" stroke-width="3" />
            <path d="M13 24h22" fill="none" stroke="#6b8ebf" stroke-width="3" stroke-linecap="round"/>
          </svg>
          <span>{{ $t('Switch Language') }}</span>
        </div>

        <div class="function-card-item" @click="$parent.goNav('/realnameAuth')">
          <svg class="function-card-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#f5f7fa" />
            <rect x="14" y="13" width="20" height="22" rx="2" fill="none" stroke="#6b8ebf" stroke-width="3"/>
            <circle cx="24" cy="20" r="3.5" fill="none" stroke="#6b8ebf" stroke-width="2.5"/>
            <path d="M17.5 31c1.5-3 4-4.5 6.5-4.5S29 28 30.5 31" fill="none" stroke="#6b8ebf" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
          <span>实名认证</span>
        </div>

        <div class="function-card-item" @click="openKefu">
          <svg class="function-card-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#f5f7fa" />
            <path d="M14 22c0-5.5 4.5-10 10-10s10 4.5 10 10v6c0 1.7-1.3 3-3 3h-2v-8h4v-1c0-4.4-3.6-8-8-8s-8 3.6-8 8v1h4v8h-2c-1.7 0-3-1.3-3-3v-6z" fill="none" stroke="#6b8ebf" stroke-width="2.5" stroke-linejoin="round"/>
            <path d="M20 34h8" stroke="#6b8ebf" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
          <span>联系客服</span>
        </div>
      </div>
    </div>

    <!--
    <div class="welfare-banner-section" @click="goNewbieBonus">
      <div class="welfare-banner-content">
        <div class="welfare-banner-text">
          <div class="welfare-banner-title">{{ $t('Newbie Exclusive Benefits') }}</div>
          <div class="welfare-banner-subtitle">{{ $t('Claim your exclusive package now') }}</div>
        </div>
        <div class="welfare-banner-button">{{ $t('Go to claim') }}</div>
      </div>
    </div>
    -->
    
    <div class="bottom-menu-section" @click="$parent.goNav('/about')">
      <div class="menu-card-item">
        <div style="display:flex; align-items:center;">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA9CAMAAAApvJHbAAAAS1BMVEVHcEwAXOAqKioqKioqKioqKioAXOAqKioqKioqKioAXOAqKioAXOAAXOAqKioqKioqKioAXOAqKioqKioqKioqKioqKioqKioAXOBocunxAAAAF3RSTlMA2p4s2cnjwALlghnMb2l/rSzk4tvuTM6TgrEAAAD2SURBVEjH7dfLEoMgDAXQCKI8xGfV/v+XloBT25kummBX5W5wcwwiMwSAENeLlhbRSzgy7JwIHfG486L4lWP18M3paSZlSUhCj0MtNS2uTcUFDg7IMVgU8CULHUeX9MzQKrhb0pqn66Kv1r7rPFv7e4hlat2gbri183Scuc9ZNQv6/3bLZO3E1XrCNZ+4tTvUXdZuqYouuuhfaZtzGgReNbac35drfsfVZtU2n/S3Xe6Yutw3vSlD67BftGxp3f0Ip5bUG4bSSZtgBetWE1dePy8nhnajwvmu5rDrQPx3/TkXtETtzg9x4W9TN812WAmsSFHXTPsABiFaUjfYl4kAAAAASUVORK5CYII=" alt="About Us" class="menu-card-icon" />
          <span>{{ $t('About Us') }}</span>
        </div>
        <img src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="Go" class="menu-card-arrow" />
      </div>
    </div>
    
    <Foot />
  </div>
</template>

<script>
import Foot from '../libs/Foot';
export default {
  name: 'mine',
  components: {
    Foot
  },
  data() {
    return {
      isRefreshing: false,
      recovering: false,
      // VIP 相关（功能暂时隐藏）
      vipProgress: 0,
      vipGrowth: 0,
      vipTarget: 63000,
      vipTab: 3,
      userVipLevel: 0,
      vipLis: [],
      userStats: {
        flow: 0
      },
      agentPromoMode: 'tier',
      currentVipFlow: 0
    };
  },
  computed: {
    nextVipInfo() {
      const currentLevel = Number(this.userVipLevel || this.$store.state.userInfo.vip || this.vipTab || 0);
      const nextVip = this.findVipByLevel(currentLevel + 1);

      if (!nextVip) {
        return null;
      }

      const rechargeRequired = Number(nextVip.recharge || 0);
      const flowRequired = Number(nextVip.flow || 0);
      const currentRecharge = Number(this.$store.state.userInfo.paysum || this.userStats.deposit || 0);
      const currentFlow = Number(this.userStats.flow || 0);

      return {
        level: currentLevel + 1,
        rechargeRemaining: Math.max(rechargeRequired - currentRecharge, 0),
        flowRemaining: Math.max(flowRequired - currentFlow, 0)
      };
    }
  },
  created() {
    let that = this;
    if (that.$store.state.token && that.$store.state.userInfo.vip) {
      that.userVipLevel = parseInt(that.$store.state.userInfo.vip) || 0;
      that.vipTab = that.userVipLevel || 3;
    }
    that.getUserInfo();
    that.refreshBalance();
    that.uservip();
    that.getUserRealData();
    that.loadAgentPromoMode();
  },
  methods: {
    formatBalance(value) {
      const balance = parseFloat(value);
      return Number.isFinite(balance) ? balance.toFixed(2) : '0.00';
    },
    formatVipAmount(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num.toFixed(2) : '0.00';
    },
    findVipByLevel(level) {
      if (!Array.isArray(this.vipLis) || !this.vipLis.length) {
        return null;
      }

      const targetLevel = Number(level);
      return this.vipLis.find(item => Number(item.id) === targetLevel) || this.vipLis[targetLevel - 1] || null;
    },
    updateVipProgressTarget() {
      const currentLevel = Number(this.userVipLevel || this.$store.state.userInfo.vip || this.vipTab || 0);
      const nextVip = this.findVipByLevel(currentLevel + 1);
      const currentVip = this.findVipByLevel(currentLevel);
      const target = Number((nextVip && nextVip.flow) || (currentVip && currentVip.flow) || 0);

      this.currentVipFlow = target;
      this.syncVipProgress();
    },
    loadAgentPromoMode() {
      this.$apiFun.post('/api/tier-rewards', {}).then(res => {
        if (res.code === 200 && res.data) {
          this.agentPromoMode = res.data.mode || 'tier';
        }
      }).catch(() => {});
    },
    openKefu() {
      if (this.$parent && typeof this.$parent.openKefu === 'function') {
        this.$parent.openKefu();
        return;
      }
      this.$parent.goNav('/kefu');
    },
    goNewbieBonus() {
      const that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/realname-status', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message || '请先登录');
          return;
        }
        if (!res.data.verified) {
          that.$dialog.confirm({
            title: '提示',
            message: '领取新人彩金前需完成实名认证',
            confirmButtonText: '去实名',
            cancelButtonText: '取消'
          }).then(() => {
            that.$parent.goNav('/realnameAuth');
          }).catch(() => {});
          return;
        }
        that.$parent.goNav('/newbieBonus');
      }).catch(() => {
        that.$parent.hideLoading();
        that.$parent.showTost(0, '网络异常');
      });
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip || '';
          let index = str.indexOf('P');
          if (index >= 0) {
            let vip = str.substr(index + 1, str.length);
            userInfo.vip = vip;
            that.userVipLevel = parseInt(vip) || that.userVipLevel || 0;
            that.vipTab = parseInt(vip) || 3;
          }

          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
          that.updateVipProgressTarget();
        }
      }).catch(err => {
        console.error('获取用户信息失败:', err);
      });
    },
    refreshBalance() {
      let that = this;
      if (that.isRefreshing) return;
      that.isRefreshing = true;
      that.$apiFun.post('/api/balance', {}).then(res => {
        if (res.code == 200 && res.data && res.data.balance !== undefined) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
        }
      }).catch(err => {
        console.error('刷新余额失败:', err);
      }).finally(() => {
        that.isRefreshing = false;
      });
    },
    async transall() {
      if (this.recovering) {
        return;
      }
      this.recovering = true;
      if (this.$parent && typeof this.$parent.showLoading === 'function') {
        this.$parent.showLoading();
      }
      try {
        const res = await this.$apiFun.post('/api/transall', {});
        const ok = Number(res.code) === 200;
        if (this.$parent && typeof this.$parent.showTost === 'function') {
          this.$parent.showTost(ok ? 1 : 0, res.message || (ok ? '回收完成' : '回收失败'));
        }
        if (ok) {
          await this.getUserInfo();
          this.refreshBalance();
        }
      } catch (error) {
        if (this.$parent && typeof this.$parent.showTost === 'function') {
          this.$parent.showTost(0, '网络异常，请稍后重试');
        }
      } finally {
        this.recovering = false;
        if (this.$parent && typeof this.$parent.hideLoading === 'function') {
          this.$parent.hideLoading();
        }
      }
    },
    syncVipProgress() {
      const flow = Number(this.userStats.flow || 0);
      const target = Number(this.currentVipFlow || 0);
      this.vipProgress = target > 0 ? Math.min((flow / target) * 100, 100) : 0;
    },
    uservip() {
      let that = this;
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code == 200 && Array.isArray(res.data)) {
            that.vipLis = res.data.slice().sort((a, b) => Number(a.id) - Number(b.id));
            that.updateVipProgressTarget();
          }
        })
        .catch(res => {
          console.log('获取 VIP 数据失败:', res);
        });
    },
    getUserRealData() {
      let that = this;
      that.$apiFun
        .post('/api/game/users', {})
        .then(res => {
          if (res.code == 200 && Array.isArray(res.data)) {
            const userData = res.data.find(user => user.id == that.$store.state.userInfo.id) || {};
            that.userStats = {
              deposit: userData.recharge || userData.deposit || userData.total_recharge || that.userStats.deposit,
              flow: userData.flow || userData.bet || userData.total_bet || userData.total_flow || that.userStats.flow,
              growth: userData.growth || userData.exp || userData.experience || that.userStats.growth,
              maxGrowth: that.userStats.maxGrowth
            };
            that.updateVipProgressTarget();
          }
        })
        .catch(res => {
          console.log('获取会员列表数据失败:', res);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// 全局背景
.background-gradient {
  background-image: linear-gradient(to bottom, #1a1a1a, #000000);
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 70px; 
  color: #e0e0e0; 
}

// 顶部蓝底区域
.top-blue-container {
  background-color: #054dc4; 
  padding-bottom: 40px; 
  border-radius: 0 0 20px 20px;
}

// 顶部导航卡片
.top-nav-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 20px 10px; 
  color: white;
  
  .top-left-avatar {
    .avatar-wrapper {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      border: 1px solid white;
    }
  }
  
  .top-center-info {
    flex: 1;
    margin-left: 15px;
    
    .username-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
      position: relative;
      
      .username-text {
        font-size: 19px;
        font-weight: 600;
        color: white;
      }
      
      .right-buttons-top {
        display: flex;
        align-items: center;
        gap: 12px;
        
        .settings-btn-top {
          display: flex;
          align-items: center;
          background-color: rgba(255, 255, 255, 0.15); 
          padding: 4px 10px;
          border-radius: 12px;
          font-size: 12px;
          color: white; 
          cursor: pointer;
          
          .icon-img {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }
        }
        
        .customer-service-top {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 30px;
          padding: 0;
          border: 1px solid rgba(255, 255, 255, 0.52);
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;

          &:active {
            background: rgba(255, 255, 255, 0.2);
          }
        }

        .customer-service-top-icon {
          width: 21px;
          height: 21px;
        }
      }
    }
    
    .days-text {
      font-size: 13px;
      opacity: 0.9;
      color: white; 
    }
  }
}

// 余额卡片区域
.balance-card-section {
  padding: 15px 20px 0px 20px; 
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  
  .balance-card-info {
    display: flex;
    align-items: center;
    
    .balance-card-label {
      font-size: 15px;
      opacity: .9;
      margin-right: 15px;
    }
    
    .balance-card-amount {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 700;
      
      .currency {
        font-size: 16px;
      }
      
      .refresh-icon-balance {
        width: 18px;
        height: 18px;
        margin-left: 8px;
        cursor: pointer;
        
        &.rotate {
          animation: rotate-sx 1s linear infinite;
        }
      }
    }
  }
    
  // 使用 CSS 精美绘制的存款和取款按钮
    .balance-card-buttons {
      display: flex;
      gap: 12px; 
      
      button {
        padding: 6px 12px;
        border: none;
        border-radius: 6px;
        font-size: 15px;
        font-weight: bold;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        white-space: nowrap;
      }
      
      .btn-deposit {
        background: linear-gradient(135deg, #6ba1ff, #3b74e6); 
        color: #ffffff;
        width: 75px; 
        height: 32px;
      }
      
      .btn-withdraw {
        background: linear-gradient(135deg, #fceb99, #d1a03e); 
        color: #8c5a1c;
        width: 75px; 
        height: 32px;
      }
    }
}

// VIP等级区域 (悬浮金色卡片) — 功能暂时隐藏，样式保留
.vip-card-section {
  margin: -30px 15px 20px; 
  position: relative;
  z-index: 10;
  box-shadow: 0 4px 15px rgba(0, 0, 0, .6);
  background-image: linear-gradient(135deg, #fceb99, #d1a03e); 
  padding: 20px 0 10px 0;
  border-radius: 16px;
  
  .vip-card-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 15px;
    padding: 0 20px;
    
    .vip-card-level {
      font-size: 18px;
      font-weight: 800;
      color: #333333; 
    }
    
    .vip-card-growth-value {
      font-size: 12px;
      color: #444444; 
      font-weight: 500;
    }
  }

  .vip-card-next-tip {
    padding: 0 20px;
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 1.45;
    color: rgba(51, 51, 51, 0.9);
    font-weight: 600;

    &.vip-card-next-tip--done {
      color: rgba(51, 51, 51, 0.7);
    }
  }
  
  .vip-card-progress {
    margin-bottom: 15px;
    padding: 0 20px;
    
    .vip-card-progress-bar {
      width: 100%;
      height: 6px;
      background-color: rgba(0, 0, 0, 0.15); 
      border-radius: 6px;
      overflow: hidden;
      
      .vip-card-progress-fill {
        height: 100%;
        background: linear-gradient(to right, #ffffff, #ffcc00); 
        border-radius: 6px;
      }
    }
  }
  
  .vip-card-tabs {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    
    .vip-card-tab {
      flex: 1;
      text-align: center;
      font-size: 13px;
      font-weight: 600;
      color: #444444; 
      padding: 8px 0;
      border-radius: 8px;
      transition: all 0.2s;
      cursor: pointer;
      
      &:hover {
        background-color: rgba(255,255,255,0.3);
        color: #1a1a1a;
      }
    }
  }
}

// 场馆余额一键回收（原 VIP 位置）
.recover-card-section {
  margin: -28px 15px 20px;
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(135deg, #1e3a6e 0%, #0d2a56 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);

  .recover-card-copy {
    flex: 1;
    min-width: 0;
  }

  .recover-card-title {
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 4px;
  }

  .recover-card-desc {
    font-size: 12px;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.72);
  }

  .recover-card-btn {
    flex-shrink: 0;
    padding: 8px 16px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 18px;
    color: #fff;
    background: rgba(255, 255, 255, 0.14);
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &:not(:disabled):active {
      background: rgba(255, 255, 255, 0.24);
    }
  }
}

// 功能按钮区
.function-grid-section {
  padding: 0 15px;
  margin-bottom: 20px;
  
  .function-grid-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr); 
    gap: 15px;
    background-color: #262626; 
    padding: 20px 10px;
    border-radius: 16px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, .5); 
    border: 1px solid rgba(255, 255, 255, 0.05); 
    
    .function-card-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 0;
      cursor: pointer;
      
      .function-card-icon {
        width: 45px;
        height: 45px;
        margin-bottom: 12px;
      }
      
      span {
        font-size: 13px;
        color: #e0e0e0; 
        font-weight: 500;
      }
    }
  }
}

// 新人福利中心横幅
.welfare-banner-section {
  margin: 0 15px 20px;
  background-image: url('https://pph5.baijin.xyz/assets/mine-new-member-banner-0o8020v_.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, .5); 
  
  .welfare-banner-content {
    display: flex;
    align-items: center;
    padding: 20px;
    
    .welfare-banner-text {
      flex: 1;
      
      .welfare-banner-title {
        font-size: 15px;
        font-weight: 600;
        color: white;
        margin-bottom: 6px;
      }
      
      .welfare-banner-subtitle {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.85);
      }
    }
    
    .welfare-banner-button {
      padding: 8px 16px;
      background: rgba(255,255,255,0.2);
      border: 1px solid rgba(255,255,255,0.4);
      color: white;
      border-radius: 20px;
      font-size: 12px;
      white-space: nowrap;
    }
  }
}

// 关于我们 (底部卡片)
.bottom-menu-section {
  margin: 0 15px 20px; 
  background-color: #262626; 
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, .5); 
  border: 1px solid rgba(255, 255, 255, 0.05);
  
  .menu-card-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    cursor: pointer;
    
    .menu-card-icon {
      width: 22px;
      height: 22px;
      margin-right: 12px;
      filter: brightness(0) invert(1) opacity(0.8);
    }
    
    span {
      font-size: 14px;
      color: #e0e0e0; 
      font-weight: 500;
      flex: 1;
    }
    
    .menu-card-arrow {
      width: 12px;
      height: 12px;
      filter: brightness(0) invert(1) opacity(0.6); 
    }
  }
}

// 动画
@keyframes rotate-sx {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* ==================== 白色个人中心主题 ==================== */
.background-gradient {
  min-height: 100vh;
  padding-bottom: 76px;
  background: #fff;
  color: #2d241d;
}

.top-blue-container {
  padding-bottom: 42px;
  border-radius: 0 0 24px 24px;
  background:
    radial-gradient(circle at 82% 8%, rgba(246, 223, 169, 0.30), rgba(246, 223, 169, 0) 34%),
    linear-gradient(135deg, #603514 0%, #965723 62%, #bd7a38 100%);
  box-shadow: 0 8px 22px rgba(96, 53, 20, 0.18);
}

.top-nav-card .top-left-avatar .avatar-wrapper {
  border: 2px solid #f6dfa9;
  box-shadow: 0 5px 14px rgba(53, 28, 9, 0.24);
}

.top-nav-card .top-center-info .username-row .right-buttons-top .settings-btn-top,
.top-nav-card .top-center-info .username-row .right-buttons-top .customer-service-top {
  border: 1px solid rgba(255, 238, 198, 0.54);
  background: rgba(255, 255, 255, 0.14);
  box-shadow: 0 3px 9px rgba(57, 28, 8, 0.12);
}

.balance-card-section .balance-card-buttons .btn-deposit {
  background: linear-gradient(135deg, #f6dfa9, #dca84f);
  color: #603514;
  box-shadow: 0 5px 12px rgba(77, 39, 11, 0.18);
}

.balance-card-section .balance-card-buttons .btn-withdraw {
  border: 1px solid rgba(255, 239, 203, 0.72);
  background: rgba(255, 255, 255, 0.92);
  color: #8b5224;
  box-shadow: 0 5px 12px rgba(77, 39, 11, 0.14);
}

.recover-card-section {
  border: 1px solid #d9aa54;
  background:
    radial-gradient(circle at 92% 10%, rgba(255, 255, 255, 0.94), rgba(255, 255, 255, 0) 34%),
    linear-gradient(135deg, #fffdf8 0%, #f7e7bd 100%);
  box-shadow: 0 9px 22px rgba(104, 69, 36, 0.13);
}

.recover-card-section .recover-card-title {
  color: #4d301a;
}

.recover-card-section .recover-card-desc {
  color: #8b7562;
}

.recover-card-section .recover-card-btn {
  border: 1px solid #bd7a38;
  background: linear-gradient(135deg, #b87537, #8a4d1f);
  color: #fff;
  box-shadow: 0 5px 12px rgba(138, 77, 31, 0.20);
}

.recover-card-section .recover-card-btn:not(:disabled):active {
  background: #7d441b;
}

.function-grid-section .function-grid-wrapper {
  gap: 12px 8px;
  border: 1px solid #eadfd2;
  background: #fff;
  box-shadow: 0 9px 24px rgba(104, 69, 36, 0.10);
}

.function-grid-section .function-grid-wrapper .function-card-item {
  padding: 10px 2px;
  border-radius: 13px;
  transition: background 0.18s ease, transform 0.18s ease;
}

.function-grid-section .function-grid-wrapper .function-card-item:active {
  transform: scale(0.97);
  background: #fbf7f1;
}

.function-grid-section .function-grid-wrapper .function-card-item .function-card-icon {
  width: 47px;
  height: 47px;
  margin-bottom: 9px;
  border: 1px solid #eadfd2;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 5px 12px rgba(104, 69, 36, 0.10);
}

.function-grid-section .function-grid-wrapper .function-card-item span {
  color: #4a3d33;
  font-weight: 600;
}

.bottom-menu-section {
  border: 1px solid #eadfd2;
  background: #fff;
  box-shadow: 0 8px 20px rgba(104, 69, 36, 0.09);
}

.bottom-menu-section .menu-card-item .menu-card-icon {
  filter: sepia(0.55) saturate(1.4) brightness(0.7);
}

.bottom-menu-section .menu-card-item span {
  color: #4a3d33;
}

.bottom-menu-section .menu-card-item .menu-card-arrow {
  filter: sepia(0.55) saturate(1.2) brightness(0.68);
}
</style>



// WEBPACK FOOTER //
// src/components/mode/mine.vue